import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CoreSidebarService} from '../../../../@core/components/core-sidebar/core-sidebar.service';
import {AlertService} from '../../../shared/services/alert.service';
import {HttpClient} from '@angular/common/http';
import {GlobalService} from '../../../shared/services/global.service';
import {ArticleCategoryService} from '../../../shared/services/article-category.service';
import {NgxTagsInputModule, TagsChangedEvent} from 'ngx-tags-input';

@Component({
    selector: 'app-add-article-category',
    templateUrl: './add-article-category.component.html',
    styleUrls: ['./add-article-category.component.scss']
})
export class AddArticleCategoryComponent implements OnChanges {
    addArticleCategoryForm: FormGroup;
    id: any;
    submitted: any = false;
    submitting: any = false;
    selectedArticle: any = [];
    @Output() valueSubmitted = new EventEmitter<any>();
    @Input() data: any;
    tags: string[] = [];

    constructor(private _coreSidebarService: CoreSidebarService,
                private fb: FormBuilder,
                private alertService: AlertService,
                public http: HttpClient,
                public globalService: GlobalService,
                private articleCategoryService: ArticleCategoryService,
                private NgxTagsInputModule: NgxTagsInputModule) {
    }

    ngOnChanges(): void {
        this.refresh();
    }

    toggleSidebar(): void {
        this._coreSidebarService.getSidebarRegistry('app-add-article-category').toggleOpen();
    }

    refresh() {
        this.addArticleCategoryForm = this.fb.group({
            'name': ['', (!this.id) ? Validators.required : ''],
            'alias': ['', (!this.id) ? Validators.required : ''],
            // 'tags': ['', (!this.id) ? Validators.required : '']
        });
        if (this.data && this.data['id']) {
            this.patchForm();
        }
    }

    // addTags(tag: string) {
    //     this.tags = tag.trim().split(' ');
    // }

    patchForm() {
        if (this.data) {
            this.getArticle(this.data['id']);
        }
        this.addArticleCategoryForm.patchValue({
            'name': (this.data && this.data['name']) ? this.data['name'] : '',
            'alias': (this.data && this.data['alias']) ? this.data['alias'] : '',
            // 'tags': (this.data && this.data['tags']) ? this.data['tags'].replace(/,/g, ' ') : ''
        });
    }

    getArticle(id) {
        this.articleCategoryService.get(id).subscribe(data => {
            if (data && data['data'].length > 0) {
                this.selectedArticle = (data && data['data']) ? data['data'] : {};
            }
        });
    }

    submit() {
        this.submitted = true;
        if (!this.addArticleCategoryForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'name': (this.addArticleCategoryForm.value && this.addArticleCategoryForm.value.name) ? this.addArticleCategoryForm.value.name : '',
                'alias': (this.addArticleCategoryForm.value && this.addArticleCategoryForm.value.alias) ? this.addArticleCategoryForm.value.alias : '',
                // 'tags': this.tags ? this.tags : '',
            };
            this.submitting = true;
            this.articleCategoryService.create(params).subscribe(data => {
                if (data) {
                    this.submitting = false;
                    this.submitted = false;
                    this.valueSubmitted.emit(true);
                    this.addArticleCategoryForm.reset();
                    this.addArticleCategoryForm.patchValue({
                        'name': '',
                        'alias': '',
                        // 'tags': ''
                    });
                }
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].name && error['error']['errors'].name.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].name[0]);
                        return;
                    }
                    if (error['error']['errors'].alias && error['error']['errors'].alias.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].alias[0]);
                        return;
                    }
                    // if (error['error']['errors'].tags) {
                    //     this.alertService.showErrors(error['error']['errors'].tags[0]);
                    //     return;
                    // }
                }
            });
        }
    }

    update() {
        this.submitted = true;
        if (!this.addArticleCategoryForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'name': (this.addArticleCategoryForm.value && this.addArticleCategoryForm.value.name) ? this.addArticleCategoryForm.value.name : '',
                'alias': (this.addArticleCategoryForm.value && this.addArticleCategoryForm.value.alias) ? this.addArticleCategoryForm.value.alias : '',
                // 'tags': this.tags ? this.tags : ''
            };
            this.submitting = true;
            this.articleCategoryService.update(this.data['id'], params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.valueSubmitted.emit(true);
                this.addArticleCategoryForm.reset();
                this.addArticleCategoryForm.patchValue({
                    'name': '',
                    'alias': '',
                    // 'tags': ''
                });
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error['error']['errors'].name && error['error']['errors'].name.length > 0) {
                    this.alertService.showErrors(error['error']['errors'].name[0]);
                    return;
                }
                if (error['error']['errors'].alias && error['error']['errors'].alias.length > 0) {
                    this.alertService.showErrors(error['error']['errors'].alias[0]);
                    return;
                }
                // if (error['error']['errors'].tags) {
                //     this.alertService.showErrors(error['error']['errors'].tags[0]);
                //     return;
                // }
            });
        }
    }
}
